<template>
  <div class="sensor-settings-row" v-if=sensor>
    <FloatLabel variant="on">
      <label>Engaged *</label>
      <Select
        v-model="sensor.engaged_signal"
        :options="usableDistance"
        optionValue="signal_strength"
        optionLabel="distance_text"
      />
    </FloatLabel>

    <FloatLabel variant="on">
      <label>Passerby *</label>
      <Select
        v-model="sensor.passerby_signal"
        :options="passerMinDist"
        optionValue="signal_strength"
        optionLabel="distance_text"
      />
    </FloatLabel>

    <Tooltip position="bottom">
      <template v-slot:text>
        <FloatLabel>
          <label>Max. Range</label>
          <Select
            v-model="totalDistance"
            :disabled="true"
            :options="sensorDistanceOptions"
            optionValue="signal_strength"
            optionLabel="distance_text"
          />
        </FloatLabel>
      </template>
      <template v-slot:tooltip>
        This is calculated automatically.
      </template>
    </Tooltip>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { SensorDistanceSettingType, SensorType } from '@/types/Sensor';

import { FloatLabel, Select } from 'primevue';

import Tooltip from '@/components/global/Tooltip.vue';

const sensor = defineModel<SensorType>('sensor');

const props = defineProps<{
  sensorDistanceOptions: SensorDistanceSettingType[]
}>();

import { useUserStore } from '@/stores/user';
const userStore = useUserStore();

const usableDistance = computed(() => {
  if (userStore.isNonStaff) {
    return props.sensorDistanceOptions.filter(dist => {
      return Math.floor(dist.distance_metres) <= 43;
    });
  }
  return props.sensorDistanceOptions;
});

const passerMinDist = computed(() => {
  if (sensor.value && sensor.value.engaged_signal) {
    return usableDistance.value.filter(dist => {
      if (sensor.value?.engaged_signal) {
        return dist.signal_strength <= (sensor.value.engaged_signal || 0);
      }
    });
  }

  return props.sensorDistanceOptions;
});

const totalDistance = computed(() => {
  const maxDistance = props.sensorDistanceOptions.find(dist => Math.floor(dist.distance_metres) === 61);
  return maxDistance?.signal_strength || null;
});

</script>
